const GenerationTimeout = Object.freeze({
  STALE_AFTER_MS: 30 * 60_000,
} as const);

export type GenerationTimeout = (typeof GenerationTimeout)[keyof typeof GenerationTimeout];

export default GenerationTimeout;
